import api from './api';

export const listLibraryMedia = (params = {}, config = {}) => api.get('/media-library', { params, ...config });
export const getLibraryMedia = (id) => api.get(`/media-library/${id}`);
export const uploadLibraryMedia = (payload, onUploadProgress) => api.post('/media-library/upload', payload, { onUploadProgress });
export const deleteLibraryMedia = (id) => api.delete(`/media-library/${id}`);
export const downloadLibraryMedia = (id) => api.get(`/media-library/${id}/download`, { responseType: 'blob' });
export const libraryMediaSource = (id) => `/api/media-library/${id}/download`;
// Media Manager additions: bounded bulk delete (library items only; the server
// re-checks every file) and a generic authenticated download for the
// read-only chat/flow categories (their URLs come from the server).
export const bulkDeleteLibraryMedia = (ids) => api.post('/media-library/bulk-delete', { ids });
export const downloadMediaFile = (url) => api.get(String(url).replace(/^\/api/, ''), { responseType: 'blob' });
